export const isPrerendering = () => {
  // Check if we are in a browser environment first
  if (typeof window === 'undefined') return false;

  // Check if user agent is Puppeteer or Headless Chrome, which we use for pre-rendering
  const userAgent = window.navigator?.userAgent || '';
  return /HeadlessChrome|Puppeteer/i.test(userAgent);
};